import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Checkbox } from 'antd';
import { txt } from 'libs/i18n';
import SpeakerColorPicker from 'components/SpeakerColorPicker';
import styles from './style.module.less';
const ColorPicker = ({ defaultSpeakerColor }) => {
    const form = Form.useFormInstance();
    const onDefaultColorChange = (value) => {
        if (value.target.checked === true) {
            form.setFieldValue(['speaker', 'captionColor'], defaultSpeakerColor);
        }
    };
    return (_jsx(Form.Item, { name: ['speaker', 'captionColor'], label: txt('speakerColor'), children: _jsx(SpeakerColorPicker, { children: _jsxs("div", { className: styles.defaultColorWrapper, children: [_jsx(Form.Item, { name: ['speaker', 'isDefaultColor'], valuePropName: "checked", noStyle: true, children: _jsx(Checkbox, { onChange: onDefaultColorChange }) }), _jsx("span", { className: styles.defaultColorText, children: txt('chooseDefaultColor') }), _jsx("div", { className: styles.colorBox, style: { backgroundColor: defaultSpeakerColor } })] }) }) }));
};
export default ColorPicker;
